import React from 'react';
import { Button } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { chakraTheme } from 'utils/chakraTheme';

const AnimatedButton = motion(Button);

export const OrderFormButton = React.memo(() => {
  return (
    <AnimatedButton
      as="a"
      mt={{ base: 2, md: 4 }}
      href="https://www.hungfooktong.com/member/germanpooljp/deliveryeform/orderform.html"
      target="_blank"
      width={{ base: '140px', md: '200px' }}
      borderRadius="3xl"
      zIndex={10}
      fontWeight="bold"
      fontSize={{ base: 14, md: 20 }}
      _focus={{ border: 'none' }}
      height={{ base: '36px', md: '48px' }}
      color={chakraTheme.colors.pink[500]}
      initial={{
        backgroundColor: 'rgba(255,255,255,0.9)',
        color: chakraTheme.colors.pink[500],
        scale: 1,
      }}
      animate={{
        backgroundColor: 'rgba(255,255,255,1)',
        color: chakraTheme.colors.pink[500],
        boxShadow: `0 0 10px 0 rgba(255,255,255,0.8)`,
        scale: 1.2,
      }}
      transition={{
        duration: 0.5,
        repeat: Infinity,
        repeatType: 'mirror',
      }}
    >
      填寫電子送貨表格
    </AnimatedButton>
  );
});
